import React from 'react';

const TreeLoadingSpinner = ({ size = 'md' }) => {
  const sizes = {
    sm: { container: 'w-16 h-16', pot: 'w-12 h-6', trunk: 'w-2 h-6', canopy: 'w-10 h-10' },
    md: { container: 'w-24 h-24', pot: 'w-16 h-8', trunk: 'w-3 h-9', canopy: 'w-14 h-14' },
    lg: { container: 'w-32 h-32', pot: 'w-20 h-10', trunk: 'w-4 h-12', canopy: 'w-18 h-18' }
  };

  const current = sizes[size];

  return (
    <div className="flex flex-col items-center justify-center">
      <div className={`relative ${current.container}`}>
        {/* Canopy - growing animation */}
        <div 
          className={`absolute ${current.canopy} rounded-full bg-gradient-to-br from-green-700/80 to-green-900/80 top-0 left-1/2 -translate-x-1/2`}
          style={{
            animation: 'canopyGrow 2s ease-in-out infinite'
          }}
        >
          {/* Inner leaves */}
          <div className="absolute inset-2 rounded-full bg-green-600/40"></div>
        </div>

        {/* Trunk */}
        <div 
          className={`absolute ${current.trunk} bg-gradient-to-br from-amber-800 to-amber-900 rounded-sm bottom-8 left-1/2 -translate-x-1/2`}
          style={{
            animation: 'trunkGrow 2s ease-in-out infinite'
          }}
        ></div>

        {/* Roots - spreading animation */}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 w-full">
          <svg width="100%" height="24" viewBox="0 0 100 24" className="opacity-60">
            {/* Left root */}
            <path
              d="M 50 0 Q 30 8 15 24"
              stroke="#78350f"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              style={{
                strokeDasharray: 50,
                animation: 'rootGrow 2s ease-in-out infinite'
              }}
            />
            {/* Center root */}
            <path
              d="M 50 0 L 50 24"
              stroke="#78350f"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              style={{
                strokeDasharray: 50,
                animation: 'rootGrow 2s ease-in-out infinite 0.2s'
              }}
            />
            {/* Right root */}
            <path
              d="M 50 0 Q 70 8 85 24"
              stroke="#78350f"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              style={{
                strokeDasharray: 50,
                animation: 'rootGrow 2s ease-in-out infinite 0.4s'
              }}
            />
          </svg>
        </div>

        {/* Pot */}
        <div 
          className={`absolute ${current.pot} bg-gradient-to-br from-stone-400 to-stone-600 rounded-b-lg bottom-0 left-1/2 -translate-x-1/2`}
          style={{ clipPath: 'polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%)' }}
        >
          <div className="absolute inset-x-2 top-0 h-2 bg-amber-900/60"></div>
        </div>
      </div>

      {/* Loading text */}
      <p className="mt-4 text-sm text-muted-foreground animate-pulse">
        Growing...
      </p>

      <style jsx>{`
        @keyframes canopyGrow {
          0%, 100% {
            transform: translateX(-50%) scale(0.9);
            opacity: 0.8;
          }
          50% {
            transform: translateX(-50%) scale(1);
            opacity: 1;
          }
        }

        @keyframes trunkGrow {
          0%, 100% {
            transform: translateX(-50%) scaleY(0.95);
          }
          50% {
            transform: translateX(-50%) scaleY(1);
          }
        }

        @keyframes rootGrow {
          0% {
            stroke-dashoffset: 50;
            opacity: 0.3;
          }
          50% {
            stroke-dashoffset: 0;
            opacity: 0.8;
          }
          100% {
            stroke-dashoffset: 50;
            opacity: 0.3;
          }
        }
      `}</style>
    </div>
  );
};

export default TreeLoadingSpinner;
